import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	position: relative;
	.highcharts-axis-labels text {
		font-size: 7px;
	}
	.highcharts-label-box {
		stroke-width: 0;
	}
`;

export const TooltipContainer = styled.ul`
	display: flex;
	flex-direction: column;
	padding: 8px 16px;
	margin: 0;
	background-color: ${colors.white};
	border: 0px;
	box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
`;

export const TooltipColor = styled.span`
	display: inline-block;
	width: 8px;
	height: 8px;
	margin-right: 8px;
	background-color: ${props => (props.color ? props.color : 'transparent')};
`;

export const TooltipItem = styled.li`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const TooltipItemName = styled.span`
	font-size: 11px;
	text-transform: capitalize;
`;

export const TooltipItemValue = styled.strong`
	font-size: 13px;
	margin-left: 12px;
`;

export const Title = styled.div`
	position: absolute;
	z-index: 1;
	top: 10px;
	left: 10px;

	font-size: 13px;
	font-weight: 400;
	line-height: 15px;
	letter-spacing: 0px;
`;
